export default {
  PER_PAGE: 10,
  PAGE: 1,
  FIRST_TIMES_CHARACTERS_LENGTH: 12,
  MIN_CHARACTERS_LENGTH: 1
};


// WEBPACK FOOTER //
// ./src/modules/user/client/Constants.js